// Shown wherever a user flagged for non-attendance is stopped from entering ballots or buying papering tickets
export const nonAttendanceMessage =
	"Your account has been flagged because you have previously won tickets to an event that you did not attend. If you would like to appeal this, please contact office@concertsforcarers.org.uk"
